// Event types as offered by the event form's Type select (EventForm.vue).
// Saved event descriptions scope to one of these, or to null = all types.

export const EVENT_TYPES = [
    {value: 'event', label: 'Event'},
    {value: 'meal', label: 'Meal'},
    {value: 'playing', label: 'Playing Tennis'},
    {value: 'watching', label: 'Watching Tennis'},
    {value: 'hotel', label: 'Hotel'},
    {value: 'tour', label: 'Tour'},
    {value: 'bus', label: 'Bus/Vehicle Transfer'},
    {value: 'car', label: 'Private Transfer'},
    {value: 'transfer', label: 'Other Transfer'}
];

export function eventTypeLabel(type) {
    const found = EVENT_TYPES.find(t => t.value === type);
    return found ? found.label : type;
}
